import Component from '@glimmer/component';

import { ReportSlideFragmentType } from 'webapp/enums/enums';

interface Args {
	type: ReportSlideFragmentType;
}

const TYPES_WITH_SVG: ReportSlideFragmentType[] = [
	ReportSlideFragmentType.BOARD,
	ReportSlideFragmentType.BLOCK,
	ReportSlideFragmentType.IMAGE,
];

const SVG_NAMES: Partial<Record<ReportSlideFragmentType, string>> = {
	[ReportSlideFragmentType.BOARD]: 'fragment-board',
	[ReportSlideFragmentType.BLOCK]: 'fragment-block',
	[ReportSlideFragmentType.IMAGE]: 'fragment-image',
};

export const CLASS_MODIFIERS: Record<ReportSlideFragmentType, string> = {
	[ReportSlideFragmentType.TITLE]: 'title',
	[ReportSlideFragmentType.IMAGE]: 'image',
	[ReportSlideFragmentType.BOARD]: 'board',
	[ReportSlideFragmentType.BLOCK]: 'block',
	[ReportSlideFragmentType.STORY_TEXT]: 'story-text',
	[ReportSlideFragmentType.PLACEHOLDER]: 'placeholder',
};

export default class ReportsSkeletonFragmentComponent extends Component<Args> {
	get isSvgType(): boolean {
		return TYPES_WITH_SVG.includes(this.args.type);
	}

	get svgPath(): string {
		const svgName = SVG_NAMES[this.args.type] || 'fragment-block';
		return `/images/svg/skeleton-screens/${svgName}.svg`;
	}

	get typeClassModifier(): string {
		return CLASS_MODIFIERS[this.args.type] || '';
	}
	<template>
		<div class="fragment-skeleton fragment-skeleton--{{this.typeClassModifier}}">
			{{#if this.isSvgType}}
				<div class="fragment-skeleton__svg-container">
					<img src={{this.svgPath}} alt class="fragment-skeleton__svg" />
					<div class="fragment-skeleton__shimmer"></div>
				</div>
			{{else}}
				<div class="fragment-skeleton__text">
					<div class="skeleton-line skeleton-line--long"></div>
					<div class="skeleton-line skeleton-line--short"></div>
				</div>
			{{/if}}
		</div>
	</template>
}
